__turbopack_context__.v({
  "root": "SearchLineTabs-module-scss-module__gzKJLq__root",
  "tab": "SearchLineTabs-module-scss-module__gzKJLq__tab",
  "tabActive": "SearchLineTabs-module-scss-module__gzKJLq__tabActive",
});
